import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiUrl, IrisApiClient } from '@iris/api-query';
import { Observable } from 'rxjs';

@Injectable()
@ApiUrl('/dms2/{iris@instanceId}')
export class IrisDmsActionsService extends IrisApiClient<unknown> {
  protected readonly httpClient: HttpClient;

  constructor() {
    const httpClient = inject(HttpClient);

    super(httpClient);
  
    this.httpClient = httpClient;
  }

  @ApiUrl(`~/folders/projects/{projectId}/root/repair`)
  repairRootFolder(projectId: number): Observable<unknown> {
    return this.httpClient.post<unknown>(this.url({ projectId }), null);
  }

  @ApiUrl(`~/files/regenerate-preview`)
  regenerateFolderPreviews(folderPath: string): Observable<unknown> {
    return this.httpClient.post<unknown>(this.url(), null, { params: { folderPath } });
  }

  @ApiUrl(`~/folders/{folderId}/reindex`)
  reindexElastic(folderId: string): Observable<unknown> {
    return this.httpClient.post<unknown>(this.url({ folderId }), null);
  }
}
